import ApiClient from '../plugins/AxiosPlugin'

export async function findLocation(){
    const url = '/.dow.geolocation.info.json'

    const res = await ApiClient.get(url)
    return res.data

}
